import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-ib-video-pause",
  "use": "icon-ib-video-pause-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-ib-video-pause\"><path d=\"M66.03392 0m64 0l128 0q64 0 64 64l0 896q0 64-64 64l-128 0q-64 0-64-64l0-896q0-64 64-64Z\" p-id=\"18109\" /><path d=\"M642.03392 0m64 0l128 0q64 0 64 64l0 896q0 64-64 64l-128 0q-64 0-64-64l0-896q0-64 64-64Z\" p-id=\"18110\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol